export default __webpack_public_path__ + "static/logo-over-blue-311x186-eadd9bb6f87784abd56fc4c9e560ef23.png";